import { z } from "zod";
import { ROUND_STATUSES } from "../constants.js";
import { idSchema, isoDateTimeSchema, moneySchema, quantitySchema } from "../primitives.js";

export const createRoundInput = z
  .object({
    skuId: idSchema,
    opensAt: isoDateTimeSchema,
    closesAt: isoDateTimeSchema,
    thresholdQty: quantitySchema,
    regularUnitPrice: moneySchema,
    dealUnitPrice: moneySchema,
  })
  .refine((v) => new Date(v.closesAt) > new Date(v.opensAt), {
    message: "마감 시각은 시작 시각보다 뒤여야 합니다",
    path: ["closesAt"],
  })
  .refine((v) => Number(v.dealUnitPrice) < Number(v.regularUnitPrice), {
    message: "공동구매 단가는 정상가보다 낮아야 합니다",
    path: ["dealUnitPrice"],
  });

export const updateRoundStatusInput = z.object({
  status: z.enum(ROUND_STATUSES),
});

export const commitInput = z.object({
  qty: quantitySchema,
});

export type CreateRoundInput = z.infer<typeof createRoundInput>;
export type CommitInput = z.infer<typeof commitInput>;
